import { render } from "./EditDocument.vue?vue&type=template&id=ae0c9360&ts=true"
import script from "./EditDocument.vue?vue&type=script&lang=ts"
export * from "./EditDocument.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__